/**
 * Returns the text to display for the direct deposit switch action/allocation in the
 * given amount selection.
 * @param amountSelection the current amount selection
 */
var getAmountStringForAllocation = function (amountSelection, getLocalizedString) {
    // TODO (Octavio): this needs to be truthy at this point -- need to update once amount selection logic is in
    if (!amountSelection)
        return '-';
    return amountSelection.action === 'full_switch'
        ? getLocalizedString('FULL_PAYCHECK')
        : amountSelection.allocation.type === 'amount'
            ? "$".concat(amountSelection.allocation.value)
            : amountSelection.allocation.type === 'percentage'
                ? "".concat(amountSelection.allocation.value, "%")
                : getLocalizedString('REMAINDER');
};
export default getAmountStringForAllocation;
